/* Kept the Mui theming as much as it was, to be checked later if it can be simplified, etc */
import { createMuiTheme as _createMuiTheme, } from '@material-ui/core';
import createSpacing from '@material-ui/core/styles/createSpacing';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
import deepmerge from 'deepmerge';
import { Color } from '../Color/Color';
import createTypography from './typography';
import createBreakpointsOptions from './breakpoints';
import { MuiOutlinedInputProps, getMuiOutlinedInputOverrides, } from './MuiOutlinedInput';
import { MuiTextFieldProps, getMuiTextFieldOverrides } from './MuiTextField';
import { MuiInputBaseProps } from './MuiInputBase';
import { getMuiListOverrides } from './MuiList';
import { getMuiListItemOverrides } from './MuiListItem';
import { getMuiInputAdornmentOverrides } from './MuiInputAdornment';
var DEFAULT_SPACING = 8;
var breakpoints = createBreakpoints(createBreakpointsOptions());
var spacing = createSpacing(DEFAULT_SPACING);
export function createMuiTheme(velocityTheme, materialUiExternalTheme) {
    var s = velocityTheme.styling;
    var palette = {
        type: 'light',
        common: {
            black: Color.black,
            white: Color.white,
        },
        primary: {
            light: s.primary.light,
            main: s.primary.dark,
            dark: s.primary.main,
            contrastText: s.primary.text,
        },
        secondary: {
            light: s.secondary.main.default,
            main: s.secondary.dark['80'],
            dark: s.secondary.dark.default,
            contrastText: s.secondary.lightcontrast.text,
        },
        success: {
            light: s.system.success.light,
            main: s.system.success.main,
            dark: s.system.success.main,
            contrastText: '#fff',
        },
        error: {
            light: s.system.error.light,
            main: s.system.error.main,
            dark: s.system.error.main,
            contrastText: '#fff',
        },
        text: {
            primary: s.interface.text.main,
            secondary: s.interface.text.light,
            disabled: s.interface.text.light,
            hint: s.interface.text.light,
        },
        background: {
            paper: s.interface.background.light,
            default: s.interface.background.main,
        },
        grey: {
            50: '#fafafa',
            100: '#f5f5f5',
            200: '#eeeeee',
            300: s.gray['20'],
            400: s.gray['40'],
            500: s.gray['60'],
            600: s.gray['80'],
            700: '#616161',
            800: '#424242',
            900: '#212121',
            A100: '#d5d5d5',
            A200: '#aaaaaa',
            A400: '#303030',
            A700: '#616161',
        },
    };
    var typography = createTypography({ palette: palette, breakpoints: breakpoints }, velocityTheme);
    var velocityBaseMuiTheme = {
        palette: palette,
        breakpoints: breakpoints,
        typography: typography,
        spacing: spacing,
    };
    var velocityMuiTheme = {
        velocity: velocityTheme,
        palette: palette,
        breakpoints: breakpoints,
        typography: typography,
        spacing: spacing,
        props: {
            MuiButtonBase: {
                disableRipple: true,
            },
            MuiInputBase: MuiInputBaseProps,
            MuiOutlinedInput: MuiOutlinedInputProps,
            MuiTextField: MuiTextFieldProps,
        },
        overrides: {
            MuiInputAdornment: getMuiInputAdornmentOverrides(velocityBaseMuiTheme),
            MuiList: getMuiListOverrides(velocityBaseMuiTheme),
            MuiListItem: getMuiListItemOverrides(velocityBaseMuiTheme),
            MuiOutlinedInput: getMuiOutlinedInputOverrides(velocityBaseMuiTheme),
            MuiTextField: getMuiTextFieldOverrides(velocityBaseMuiTheme),
        },
    };
    var muiThemeOptions = materialUiExternalTheme
        ? deepmerge(materialUiExternalTheme, velocityMuiTheme)
        : velocityMuiTheme;
    return _createMuiTheme(muiThemeOptions);
}
//# sourceMappingURL=index.js.map